<div class="d-flex align-items-center gap-2">
  <ng-container
    *ngFor="
      let breadcrumb of breadcrumbs;
      trackBy: trackByFn;
      last as isLastItem
    "
  >
    <a
      class="text-sm text-gray-dark text-decoration-none"
      [routerLink]="[breadcrumb.route]"
      [queryParams]="breadcrumb.queryParams ? breadcrumb.queryParams : null"
      routerLinkActive="text-black fw-500"
      [routerLinkActiveOptions]="{ exact: true }"
      >{{ breadcrumb.label }}</a
    >
    <ng-container *ngIf="!isLastItem">
      <span class="text-sm text-gray-dark">/</span>
    </ng-container></ng-container
  >
</div>
